import { render } from 'preact';
import convertDataAttributesToObject from '@project/scripts/lib/convertDataAttributesToObejct';

class Widget {
  constructor(protected element: HTMLElement, protected moduleName: string) {
    this.init();
  }

  init() {
    import((`./${this.moduleName}/index`)).then((exports) => {
      const WidgetComponent = exports[this.moduleName];
      const formattedArgs = convertDataAttributesToObject(this.element.dataset ?? {});

      if (WidgetComponent) {
        render((<WidgetComponent dataset={formattedArgs} />), this.element);
      }
    });
  }
}

export default Widget;
